export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.7-1704.26",
  commitId: "06cb67ff4aaf327c9f7a48d153aaa6e85a03adbc",
  commitTime: "2026-10-07T17:04:26.000Z",
});
